var _circle, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgView(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#FEDBF6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 48C47.364 48 53.3333 40 53.3333 40C53.3333 40 47.364 32 40 32C32.636 32 26.6666 40 26.6666 40C26.6666 40 32.636 48 40 48Z",
    stroke: "#EF11BC",
    strokeOpacity: 0.5,
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40 43.3333C40.884 43.3333 41.7319 42.9821 42.357 42.357C42.9821 41.7319 43.3333 40.8841 43.3333 40C43.3333 39.1159 42.9821 38.2681 42.357 37.643C41.7319 37.0179 40.884 36.6667 40 36.6667C39.1159 36.6667 38.2681 37.0179 37.6429 37.643C37.0178 38.2681 36.6666 39.1159 36.6666 40C36.6666 40.8841 37.0178 41.7319 37.6429 42.357C38.2681 42.9821 39.1159 43.3333 40 43.3333Z",
    stroke: "#EF11BC",
    strokeOpacity: 0.5,
    strokeWidth: 4,
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/view.0b6fb24f172d822cb4c39ba7eb984479.svg";
export { ForwardRef as ReactComponent };